import { useTranslation } from 'react-i18next';

import { Button } from '@repo/ui/components/common';
import { cn } from '@repo/utils/common';

import { resolveWarrantyUrl } from '@/shared/utils/warranty.utils';

import { WarrantyIcon } from '@/components/toolbar/WarrantyIcon';

interface WarrantyLinkProps {
  className?: string;
}

export const WarrantyLink = ({ className }: WarrantyLinkProps) => {
  const { t, i18n } = useTranslation();

  return (
    <Button
      asChild
      variant="link"
      aria-label={t('common.threeYearWarranty', 'Three Year Warranty')}
      className={cn('items-center justify-center px-2! py-0! hover:bg-white', className)}
    >
      <a href={resolveWarrantyUrl(i18n.language)} target="_blank" rel="noopener noreferrer">
        <WarrantyIcon className="size-8 shrink-0" />
      </a>
    </Button>
  );
};
